<template style="">
  <div class="add_Column">
    <el-form :model="ruleForm" style="padding-top:20px" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

      <el-form-item label="上级栏目">
        <el-cascader ref="wcascader" v-model="ruleForm.PItemKey" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable :placeholder="placeholderdata"></el-cascader>
      </el-form-item>

      <el-form-item label="栏目代号" prop="ItemCode">
        <el-input v-model="ruleForm.ItemCode" placeholder="请输入栏目代号"></el-input>
      </el-form-item>

      <el-form-item label="栏目名称" prop="ItemName">
        <el-input v-model="ruleForm.ItemName" placeholder="请输入栏目名称"></el-input>
      </el-form-item>

      <el-form-item label="栏目类型" prop="ItemType">
        <el-radio-group v-model="ruleForm.ItemType">
          <el-radio label="书籍栏目"></el-radio>
          <el-radio label="新闻栏目"></el-radio>
          <el-radio label="素材栏目"></el-radio>
          <el-radio label="素材-图片栏目"></el-radio>
          <el-radio label="素材-音频栏目"></el-radio>
          <el-radio label="素材-视频栏目"></el-radio>
          <el-radio label="素材-文档栏目"></el-radio>
          <el-radio label="功能栏目"></el-radio>=
        </el-radio-group>
      </el-form-item>

      <el-form-item label="栏目logo地址">
        <el-input v-model="ruleForm.ItemCover" placeholder="请输入栏目logo地址"></el-input>
      </el-form-item>

      <el-form-item label="链接地址">
        <el-input v-model="ruleForm.ItemLinkURL" placeholder="请输入链接地址"></el-input>
      </el-form-item>

      <el-form-item label="排序">
        <el-input v-model="ruleForm.LineNumber" placeholder="请输入排序"></el-input>
      </el-form-item>

      <el-form-item label="是否启用">
        <el-switch v-model="ruleForm.IsActive"></el-switch>
      </el-form-item>

       <el-form-item label="栏目介绍" prop="desc">
        <el-input maxlength="200" type="textarea" v-model="ruleForm.Description" placeholder="请输入栏目介绍"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button type="primary" @click="go()">返回</el-button>
      </el-form-item>

    </el-form>

  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [],
      id: '',
      placeholderdata:'请选择上级栏目',
      ruleForm: {
        PItemKey: "",//上级栏目
        ItemCode: "",//栏目代号
        ItemName: "",//栏目名称
        ItemType: "",//栏目类型(单选)
        ItemCover: "",//栏目logo地址
        ItemLinkURL: "",//链接地址
        LineNumber: "",//排序
        IsActive: true,//是否启用0否1是
        Description: ""//栏目简介
      },
      rules: {
        PItemKey: [
          { required:true,message:'请选择上级栏目',trigger:'change' }
        ],
        ItemCode: [
          { required:true,message:'请输入栏目代号',trigger:'blur' },
        ],
        ItemName: [
          { required:true,message:'请输入栏目名称',trigger:'blur' }
        ],
        ItemType: [
          { required:true,message:'请选择栏目类型',trigger:'change' }
        ],
      }
    }
  },
  mounted() {
    this.id = [this.$route.query.id][0];
    this.$Http_Post('management/columnManagementEchoData', { ItemKey: [this.$route.query.id][0] }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.ruleForm = {
          PItemKey: '',//上级栏目
          // PItemKey: res.Data.ItemCollects,//上级栏目
          ItemCode: res.Data.ItemCode, //栏目代号
          ItemName: res.Data.ItemName,//栏目名称
          ItemType: res.Data.ItemType,//栏目类型(单选)
          ItemCover: res.Data.ItemCover,//栏目logo地址
          ItemLinkURL: res.Data.ItemLinkURL,//链接地址
          LineNumber: res.Data.LineNumber,//排序
          IsActive: res.Data.IsActive == 1 ? true:false,//是否启用 0否 1是
          Description: res.Data.Description,//栏目简介
        }
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/updateColumnInfo',{ItemKey:[this.$route.query.id][0]}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.ruleForm.PItemKey = res.Data.ParentItemids//上级栏目
        this.placeholderdata = res.Data.PItemName;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/getColumnManagementByNode',{ PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
    
  },
  methods: {
    go() {
      this.$router.push('/propagate/Column_management');
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('management/exitColumnManagement', {
            ItemKey: [this.$route.query.id][0],
            PItemKey: this.ruleForm.PItemKey.length >=1? this.ruleForm.PItemKey:[0],//上级栏目
            ItemCode: this.ruleForm.ItemCode,//栏目代号
            ItemName: this.ruleForm.ItemName,//栏目名称
            ItemType: this.ruleForm.ItemType,//栏目类型(单选)
            ItemCover: this.ruleForm.ItemCover,//栏目logo地址
            ItemLinkURL: this.ruleForm.ItemLinkURL,//链接地址
            LineNumber: this.ruleForm.LineNumber,//排序
            IsActive: this.ruleForm.IsActive? '1':'0',//是否启用0否1是
            Description: this.ruleForm.Description
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
              this.$router.push('/propagate/Column_management');
            } else {
              this.Global.request_failure(res.Message);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    Selected_to_shut_dow(dt) {
      this.ruleForm.name = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].value == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].value != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },

    bumen(dt) {
      let obj = this.data[0]
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].value == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].value != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].value == '-2') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/management/getColumnManagementByNode', { PItemKey: dt[dt.length - 1],pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },
  },
}
</script>
<style>
.add_Column{width: 100%;height: 100%;background-color: #fff;}
.add_Column .el-input__inner{width: 300px;}
.add_Column .el-textarea__inner{width: 500px !important;}
</style>
